/* eslint-disable */
/* this file is generated by generateIcons script */

import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class WorkloadsIcon extends BaseIcon {
  getChildren = () => [ <g><g><path d="M4,0V2H6V0ZM7,0V2H9V0Zm3,0V2h2V0ZM3,4.45v7.1A1.45,1.45,0,0,0,4.45,13h7.1A1.45,1.45,0,0,0,13,11.55V4.45A1.45,1.45,0,0,0,11.55,3H4.45A1.45,1.45,0,0,0,3,4.45ZM0,4V6H2V4ZM14,4V6h2V4ZM0,7V9H2V7ZM14,7V9h2V7ZM0,10v2H2V10Zm14,0v2h2V10ZM4,14v2H6V14Zm3,0v2H9V14Zm3,0v2h2V14Z" fill={this.getColor()}/></g></g> ]
  getViewBox = () => '0 0 16 16'
}
